<template>
  <div class="site__body">
    <div class="block-header block-header--has-breadcrumb block-header--has-title">
      <div class="container">
        <div class="block-header__body">
          <div class="flexbox-page-info-container">
            <div class="flex-item-page-info-breadcrumbs">
              <nav class="breadcrumb block-header__breadcrumb block-header__breadcrumb-bottom-adjust"
                aria-label="breadcrumb">
                <ol class="breadcrumb__list">
                  <li class="breadcrumb__spaceship-safe-area"
                    role="presentation"></li>
                  <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                    <router-link to="/home" class="breadcrumb__item-link">Home</router-link>
                  </li>
                  <li class="breadcrumb__item breadcrumb__item--parent" >
                    <router-link to="/select-parts-drilldown" class="breadcrumb__item-link">{{catclass}} Product Search</router-link>
                  </li>
                  <li class="breadcrumb__item breadcrumb__item--current breadcrumb__item--last"  aria-current="page">
                    <span class="breadcrumb__item-link">Search Results</span>
                  </li>
                  <li class="breadcrumb__title-safe-area" role="presentation" ></li>
                </ol>
              </nav>
            </div>

            <div class="flex-item-page-info-title">
                <h1 class="block-header__breadcrumb-slim">{{catclass}} Search Results</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <active-vehicle @selected_new_vehicle="selected_new_vehicle"></active-vehicle>
      </div>
    </div>

    <div class="block-split">
      <div class="container">
        <div class="block-split__row row no-gutters">
          <!-- <search-results-filter></search-results-filter> -->
          <div class="block-split__item block-split__item-content col-auto">
            <div class="sticky">
              <div class="flexbox-container--exhaust-diagram sticky" id="ExhaustDiagram" v-if="show_smart">
                  <div class="card sticky">
                      <iframe :src="smartPageUrl" width="100%" height="600" frameborder="0" id="partsTopImage" class="partsTopImageFrame">
                      </iframe>
                  </div>
              </div>

              <div class="flexbox-container--vehicle-selection-form">
                <base-message
                  v-if="servermessages.length > 0"
                  :servermessages="servermessages"
                ></base-message>

                <page-display-options-search 
                  @changePerPage="changePerPage" :total_results="total_results" 
                  @toggleSmartSection="toggleSmartSection"
                  @filterPrice="filterPrice"
                  @filterAvailability="filterAvailability"
                  @hasSmart="hasSmart"
                  :keyword="keyword"
                  ref="displayOptions"
                  :currentPage="$route.name">
                </page-display-options-search>

                <search-results-list 
                  @total_items="total_items" 
                  :perPage="perPage" :currentPage='page' 
                  @total_showing="total_showing"
                  @open-smart="open_smart"
                  @no-smart="hasSmart = false"
                  :filter_price="filter_price"
                  :filter_availability="filter_availability"
                  :keyword="keyword"
                  :search_type="search_type"
                  ref="search_lists"
                ></search-results-list>
              </div>
            </div>
          </div>
        </div>
        <div class="block-space block-space--layout--before-footer"></div>
      </div>
    </div>


  </div>
</template>

<script>
// import SearchResultsFilter from "./SearchResultsFilter";
import PageDisplayOptionsSearch from "./PageDisplayOptionsSearch";
import SearchResultsList from "./SearchResultsList";
// import ActiveVehicle from '../../common/vehicle/ActiveVehicle';
// import Pagination from "../productbrowse/Pagination";
// import BasePagination from '../../base/BasePagination.vue';
import { mapGetters } from 'vuex';
import ActiveVehicle from '../../common/vehicle/ActiveVehicle.vue';

export default {
  name: "SearchResults",
  components: {
    // SearchResultsFilter,
    PageDisplayOptionsSearch,
    SearchResultsList,
    ActiveVehicle
    // ActiveVehicle,
    // Pagination,
    // BasePagination,
  },
  props: {
    keyword : {
      type: String
    },
    search_type: {
      type: String
    }
  },
  data() {
    return {
      page: 1,
      perPage: 10,
      pages: [],
      total_results: 0,
      showing: 0,
      servermessages: [],
      smartPageUrl: '',
      show_smart: false,
      hasSmart: false,
      filter_price: '',
      filter_availability: '',
    };
  },

  methods: {
    total_items(total) {
      this.total_results = total;
      this.pages = [];
      let numberOfPages = Math.ceil(this.total_results / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
          this.pages.push(index);
      }
    },

    total_showing(total) {
      this.showing = total;
    },

    updatePage(currentPage){
      this.page = currentPage;
    },

    changePerPage(newPerPage){
      this.page = 1;
      this.perPage = newPerPage;
      this.total_items(this.total_results);
    },

    open_smart(url){
      this.smartPageUrl = url;
      this.show_smart = true;
      this.hasSmart = true;
      this.$refs.displayOptions.toggleShowBtn();
      // console.log('this.hasSmart = ' + this.hasSmart);
    },
    toggleSmartSection(val) {
      console.log('toggle Smart Section' + val);
      this.show_smart = val;
    },
    filterPrice(filterVal) {
      this.filter_price = filterVal
    },
    filterAvailability(filterVal) {
      this.filter_availability = filterVal
    },

    selected_new_vehicle(){
      // console.log('selected_new_vehicle');
      this.$refs.search_lists.clearList();
      setTimeout(() => {
        this.$refs.search_lists.searchParts();  
      }, 500);
      
    }
  },
  computed: {
      ...mapGetters("message", [
          "sharedmessages",
          "sharedmessagestatus"
      ]),
      ...mapGetters('api', [
          "catclass",
      ]),

  },

  watch: {
      sharedmessagestatus(newVal) {
        if (newVal === 'complete') {
          // This indicates that messages were stored on the state
          let msgs = this.$store.getters['message/sharedmessages']

          if (msgs["SearchResults"] != undefined) {
            this.servermessages = msgs["SearchResults"];
          }

        }
        this.$store.dispatch("message/resetStatus");

      },
  },

  created() {
    this.$ga.page({
        page: this.$route.fullPath,
        title: this.$route.name,
    });

    this.servermessages = [];
  }
};
</script>

<style scoped>
  .block-split__item-content{
    width: 100%;
  }

  .partsTopImageFrame {
    height: 600px !important;
  }
</style>

<style>
  .text-cart-item-manufacturer p {
      margin : 0px !important;
  }
</style>